import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { openSettings } from '@/features/settings/settings-navigation';
import { useSettingsDeepLinkTarget } from '@/features/settings/useSettingsDeepLink';
import { NoTeamView } from '@/features/team/components/NoTeamView';
import { TeamDashboardSkeleton } from '@/features/team/components/TeamDashboardSkeleton';
import { TeamDashboardView } from '@/features/team/components/TeamDashboardView';
import { teamApis } from '@/features/team/team.query';
import { teamStore } from '@/features/team/team.store';
import { parseTeamTab } from '@/features/team/team.types';

export const TeamDashboardSettings = observer(() => {
  const { item } = useSettingsDeepLinkTarget();

  useEffect(() => {
    teamApis.fetchDashboard();
    teamApis.fetchPricing();
  }, []);

  if (!teamStore.dashboard) {
    return teamStore.isLoading ? <TeamDashboardSkeleton /> : <NoTeamView />;
  }

  return (
    <TeamDashboardView
      dashboard={teamStore.dashboard}
      tab={parseTeamTab(item, teamStore.isAdmin)}
      onTabChange={(nextTab) => openSettings('Team', nextTab)}
    />
  );
});
